import { request } from "utils/request";
import { AxiosPromise } from "axios";
import { TechnicalCommissionStatus } from "types/technicalCommission";

export const technicalCommissionApi = {
  findAll: (params: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/technical-commission",
      params,
    }),

  monthlyChart: (scope: "chuong" | "dung", year: number): AxiosPromise<any> =>
    request({
      url: "/v1/admin/technical-commission/chart",
      params: { scope, year },
    }),

  updateStatus: (ids: number[], status: TechnicalCommissionStatus | null): AxiosPromise<any> =>
    request({
      url: "/v1/admin/technical-commission/status",
      method: "patch",
      data: { ids, status },
    }),

  updatePaidDate: (id: number, paidDate: string): AxiosPromise<any> =>
    request({
      url: "/v1/admin/technical-commission/paid-date",
      method: "patch",
      data: { id, paidDate },
    }),
};
